import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/warehouse/tiktok/package/index",
    params,
    method: "get"
  });
};

export const upload = data => {
  return axios.request({
    url: "/warehouse/tiktok/package/upload/" + data.id,
    method: "post",
    data: data.data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
  });
};

export const orders = id => {
  return axios.request({
    url: "/warehouse/tiktok/package/order/" + id,
    method: "get"
  });
};

export const weight = data => {
  return axios.request({
    url: "/warehouse/tiktok/package/weight/" + data.id,
    method: "post",
    data
  });
};
